import React, { useState, useEffect } from 'react';
import ConfigRouter from './ConfigRouter';
import LoadingIndicator from './globals/Components/Loading/LoadingIndicator';
import { isAuthenticated } from './Services/auth';
import InactivityGuard from './Services/InactivityGuard';
const App: React.FC = () => {
    const [loggedIn, setLoggedIn] = useState(isAuthenticated());

  useEffect(() => {
    // Revisa cada segundo si el estado de sesión cambió
    const interval = setInterval(() => {
      setLoggedIn(isAuthenticated());
    }, 1000);

    return () => clearInterval(interval);
  }, []);
  return(
    <>
    {loggedIn && <InactivityGuard />}
        <ConfigRouter />
        <LoadingIndicator />
    </>

  )
};

export default App;